import { AUTH_TOKEN_KEY, EnvironmentTypes, getEnvironment } from '@raisin/cp-utils';
import localStorage from 'store2';

export function getAuthorizationToken() {
  const isLocalEnv = getEnvironment() === EnvironmentTypes.LOCAL;
  const auth = localStorage(AUTH_TOKEN_KEY);
  const token = auth?.access_token;

  if (isLocalEnv) return token ? `Bearer ${token}` : 'Bearer jwt';

  return `Bearer ${token}`;
}
